import { defineMessages } from 'react-intl';

export default defineMessages({
    linkExpired: {
        id: 'adac.link-expired-page.Link expired',
        defaultMessage: 'Link expired'
    },
    linkNotValid: {
        id: 'adac.link-expired-page.This link is no longer valid. Please contact us again so we can send you a new one',
        defaultMessage: 'This link is no longer valid. Please contact us again so we can send you a new one.'
    },
    backButton: {
        id: 'adac.link-expired-page.Back',
        defaultMessage: 'Back'
    }
});
